import React from 'react';
import { getTxt } from 'global/appGlobal';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { graphql, compose } from 'react-apollo';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ComponentEx from 'components/ComponentEx';

import { globalSettingsQuery, updateSettingsMutation } from './qlobalSettingQueriess';
import c from '../../components/form/Components';
import LinearProgressEx from '../../components/LinearProgressEx';
import MaterialForm from '../../components/form/MaterialForm';
import { EntityTypes } from '../../global/entityDescriptors';

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing.unit * 2,
        margin: theme.spacing.unit * 2,
    },
    smtpSection: {
        marginTop: theme.spacing.unit * 4,
        padding: theme.spacing.unit * 3,
        backgroundColor: '#fafafa',
        border: '1px solid #e0e0e0',
        borderRadius: 4,
    },
    sectionTitle: {
        marginBottom: theme.spacing.unit * 2,
        fontWeight: 600,
    },
    saveButton: {
        marginTop: theme.spacing.unit * 2,
    },
    feedbackMsg: {
        marginTop: theme.spacing.unit * 1,
        fontWeight: 500,
    }
});

class Global_Settings_Edit extends ComponentEx {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleSmtpChange = this.handleSmtpChange.bind(this);
        this.saveSmtp = this.saveSmtp.bind(this);
    }

    state = {
        smtp: {
            host: '',
            port: 465,
            secure: true,
            user: '',
            pass: '',
            from: ''
        },
        smtpLoading: false,
        smtpFeedback: '',
        smtpError: false
    };

    componentDidMount() {
        this.fetchSmtpConfig();
    }

    fetchSmtpConfig() {
        const apiUrl = window.apiUrl || '/api/';
        fetch(`${apiUrl}smtp`, { credentials: 'same-origin' })
            .then(res => res.json())
            .then(data => {
                if (data && !data.error) {
                    this.setState({
                        smtp: {
                            host: data.host || '',
                            port: data.port || 465,
                            secure: data.secure === true,
                            user: data.user || '',
                            pass: data.pass || '',
                            from: data.from || ''
                        }
                    });
                }
            })
            .catch(err => console.error('Errore caricamento parametri SMTP:', err));
    }

    handleSmtpChange(field, value) {
        this.setState(prevState => ({
            smtp: {
                ...prevState.smtp,
                [field]: value
            },
            smtpFeedback: ''
        }));
    }

    saveSmtp() {
        this.setState({ smtpLoading: true, smtpFeedback: '', smtpError: false });
        const apiUrl = window.apiUrl || '/api/';

        fetch(`${apiUrl}smtp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(this.state.smtp)
        })
            .then(res => res.json())
            .then(res => {
                this.setState({
                    smtpLoading: false,
                    smtpFeedback: res.success ? 'Parametri SMTP salvati con successo!' : 'Errore nel salvataggio.',
                    smtpError: !res.success
                });
            })
            .catch(err => {
                console.error(err);
                this.setState({
                    smtpLoading: false,
                    smtpFeedback: 'Errore di connessione al server durante il salvataggio.',
                    smtpError: true
                });
            });
    }

    onSubmit(e, { obj, showErrors, hideErrors }) {
        obj.settings_id = 1;
        this.props.updateSettings({
            variables: { settings: obj },
            refetchQueries: [
                {
                    query: globalSettingsQuery,
                },
            ],
        }, this).then((resp) => {
            hideErrors();
            if (resp.errors && resp.errors.length > 0) {
                this.showServerErrors(resp.errors);
            }
            const serverErrors = resp.data && resp.data.updateSettings ? resp.data.updateSettings.validation : null;
            if (serverErrors && serverErrors.length > 0) {
                showErrors(serverErrors);
            }
        });
    }

    render() {
        const { classes } = this.props;
        const loading = this.props.data.loading;
        const item = this.props.data.globalSettings;
        const caption = getTxt('Global Settings');
        const { smtp, smtpLoading, smtpFeedback, smtpError } = this.state;

        return (
            <div className={classes.root}>
                <Typography variant="h4" color="inherit" noWrap={false}>{caption}</Typography>
                <LinearProgressEx loading={loading || smtpLoading} />

                {item && (
                    <MaterialForm
                        dataSource={item}
                        objType={EntityTypes.GlobalSettings}
                        onSubmit={this.onSubmit}
                        onChange={this.formChanged}
                    >
                        <c.group l={getTxt('Mail Notifications')} />
                        <c.field f="new_customer_notification_subject" sm={12} />
                        <c.field f="new_customer_notification_body" multiline sm={12} />
                        <c.formButtons sm={12} onCancel={() => { this.props.history.goBack(); }} />
                    </MaterialForm>
                )}

                {/* --- SEZIONE CONFIGURAZIONE SMTP --- */}
                <Paper className={classes.smtpSection} elevation={0}>
                    <Typography variant="h6" className={classes.sectionTitle}>
                        Parametri Server Posta (SMTP)
                    </Typography>

                    <Grid container spacing={24}>
                        <Grid item xs={12} sm={8}>
                            <TextField
                                label="SMTP Host / Server"
                                fullWidth
                                value={smtp.host}
                                onChange={e => this.handleSmtpChange('host', e.target.value)}
                                placeholder="es. smtp.libero.it o smtp.gmail.com"
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Porta SMTP"
                                type="number"
                                fullWidth
                                value={smtp.port}
                                onChange={e => this.handleSmtpChange('port', e.target.value)}
                                placeholder="465 o 587"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Nome Utente / Indirizzo Mittente"
                                fullWidth
                                value={smtp.user}
                                onChange={e => this.handleSmtpChange('user', e.target.value)}
                                placeholder="email@dominio.it"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Password SMTP / App Password"
                                type="password"
                                fullWidth
                                value={smtp.pass}
                                onChange={e => this.handleSmtpChange('pass', e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={smtp.secure}
                                        onChange={e => this.handleSmtpChange('secure', e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="Connessione SSL/TLS Diretta (Porta 465 = ON, Porta 587 STARTTLS = OFF)"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.saveSmtp}
                                disabled={smtpLoading}
                                className={classes.saveButton}
                            >
                                Salva Parametri SMTP
                            </Button>

                            {smtpFeedback && (
                                <Typography
                                    variant="body2"
                                    className={classes.feedbackMsg}
                                    style={{ color: smtpError ? '#d32f2f' : '#2e7d32' }}
                                >
                                    {smtpFeedback}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        );
    }
}

export default compose(
    graphql(updateSettingsMutation, {
        name: 'updateSettings',
        options: {
            errorPolicy: 'all',
        },
    }),
    graphql(globalSettingsQuery, {
        options: props => ({
            fetchPolicy: 'network-only',
            options: {
                errorPolicy: 'all',
            },
        }),
    }),
)(withStyles(styles)(Global_Settings_Edit));